import { AVATAR_EMOJI_OPTIONS, DEFAULT_AVATAR_EMOJI } from '../config/avatar-emojis.js';

/**
 * @param {object} opts
 * @param {string} opts.name — form field name for hidden input
 * @param {string} [opts.selected]
 * @param {string} [opts.inputId]
 */
export function renderAvatarEmojiPicker({ name, selected = DEFAULT_AVATAR_EMOJI, inputId }) {
  const value = selected || DEFAULT_AVATAR_EMOJI;
  const id = inputId ?? `avatar-emoji-${name}`;
  const buttons = AVATAR_EMOJI_OPTIONS.map(
    (emoji) => `
      <button
        type="button"
        class="emoji-picker__btn${emoji === value ? ' emoji-picker__btn--active' : ''}"
        data-emoji-value="${emoji}"
        aria-label="Emoji ${emoji}"
        aria-pressed="${emoji === value ? 'true' : 'false'}"
      >${emoji}</button>
    `,
  ).join('');

  return `
    <div class="emoji-picker" data-emoji-picker>
      <input type="hidden" name="${name}" id="${id}" value="${value}" data-emoji-input />
      <div class="emoji-picker__grid" role="listbox" aria-label="Scegli emoji">
        ${buttons}
      </div>
    </div>
  `;
}

/** @param {ParentNode} root */
export function bindAvatarEmojiPicker(root) {
  root.querySelectorAll('[data-emoji-picker]').forEach((picker) => {
    const input = picker.querySelector('[data-emoji-input]');
    if (!input) return;

    picker.querySelectorAll('[data-emoji-value]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const emoji = btn.dataset.emojiValue;
        input.value = emoji;
        picker.querySelectorAll('[data-emoji-value]').forEach((b) => {
          const active = b.dataset.emojiValue === emoji;
          b.classList.toggle('emoji-picker__btn--active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  });
}

export function readAvatarEmojiFromForm(form, fieldName = 'avatarEmoji') {
  const raw = String(new FormData(form).get(fieldName) ?? '').trim();
  if (AVATAR_EMOJI_OPTIONS.includes(raw)) return raw;
  return DEFAULT_AVATAR_EMOJI;
}
